import { StyleSheet } from 'react-native';
import { checkFont } from '../func';

const createStyles = (styleData: Record<string, any>) => {
  return StyleSheet.create({
    container: {
      display: 'flex',
      flexDirection: 'row',
      height: 40,
      width: styleData.width,
      opacity: styleData.opacity,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor:
        styleData.type === 'contained' ? styleData.backgroundColor : '#4A90E2',
      borderRadius: styleData.borderRadius,
      borderWidth: 1,
      borderColor: '#4A90E2',
      position: 'relative',
      overflow: 'hidden',
    },
    iconImage: {
      height: 40,
      width: 40,
    },
    textWrapper: {
      height: 60,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    text: {
      fontSize: styleData.fontSize,
      color: styleData.type === 'contained' ? '#4A90E2' : styleData.color,
      fontFamily: checkFont(styleData.fontFamily),
      fontWeight: styleData.styles?.fontWeight?.toString(),
      opacity: styleData.opacity,
      textAlign: 'center',
    },
    errorContainer: {
      flexDirection: 'row',
      borderRadius: styleData.borderRadius,
      opacity: styleData.opacity,
      textAlign: 'center',
      borderColor: '#000000',
      borderWidth: 2,
    },
    errorText: {
      padding: 5,
      margin: 'auto',
      fontSize: 16,
      color: '#ff0000',
      fontFamily: styleData.styles?.fontFamily,
      fontWeight: styleData.styles?.fontWeight?.toString(),
    },
  });
};

export default createStyles;
